<template>
    <div class="body">
        <div class="main-navi">
            <div class="navi-wrap clear">
                <h1>
                    <a href="/how_intro">
                        <img src="../../assets/img/how/logo.png" alt="How 로고">
                    </a>
                </h1>
                <ul class="pc-navi">
                    <li>
                        <span style="cursor:pointer;" @click="is_login = true">로그인</span>
                    </li>
                </ul>
                <span class="m-navi-btn pointer" style="cursor:pointer;" @click="is_login = true">
                    로그인
                </span>
            </div>
        </div>
        <!-- 메인 비쥬얼 -->
        <div class="main-visual clear">
            <div class="wrap clear">
                <div class="how-title-wrap">
                    <h2>
                        개인정보 처리방침
                    </h2>
                </div>
            </div>
            <div class="main-bg"></div>
        </div>
         <div class="index-con">
            <div class="wrap">
개인정보 처리방침<br>
㈜캐럿솔루션즈(이하 HOW 또는 회사라고 함)은 개인정보보호법, 통신비밀보호법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 정보통신서비스제공자가 지켜야할 관련 법령상의 개인정보보호 규정을 준수하고 있습니다.<br>
당사의 개인정보처리방침은 정부의 법률/지침 변경 혹은 HOW의 약관 및 내부 정책에 따라 변경될 수 있으며, 이를 개정/변경하는 경우 당사의 홈페이지에 변경사항을 즉시 게시하고 있습니다.<br>
<br>
<span style="font-weight: bold;">본 개인정보처리방침의 목차는 아래와 같습니다.<br>
수집하는 개인정보의 항목 및 수집방법<br>
개인정보의 수집 및 이용목적<br>
개인정보의 보유 및 이용기간<br>
개인정보의 파기절차 및 방법<br>
개인정보<br>
수집한 개인정보의 위탁<br>
이용자 및 법정대리인의 권리와 그 행사방법<br>
개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항<br>
개인정보 위탁 현황<br>
개인정보 관리 책임자<br>
고지의 의무<br></span>
<br>
<span style="font-weight: bold;">1. 수집하는 개인정보의 항목 및 수집방법</span><br>
HOW는 온라인 및 모바일 회원가입, 상담, 서비스 신청 등등을 위해 아래와 같은 개인정보를 수집하고 있습니다.<br>
가. 수집하는 개인정보 항목<br>
1) HOW 회원 가입 시 아래와 같은 정보를 수집합니다.<br>
- 필수항목 : 이름, 이메일, 소속(회사)<br>
- 선택항목 : 영어이름, 주소, 연락처, 부서, 직급, 사번, HR여부<br>
 2) 서비스 이용과정이나 사업 처리과정에서 아래와 같은 정보들이 생성되어 수집될 수 있습니다.<br>
 - 웹사이트 이용 시: 서비스 이용기록, 접속로그, 쿠키, 접속IP정보, 결제기록<br>
 - 모바일 이용 시: 서비스 이용 기록, 접속 로그, 기기고유번호(디바이스 아이디 또는 IMEI)<br>
 3) 고객 상담 시 서비스 품질 향상을 위해 담당자 연결 후 통화내용이 녹음되어 아래와 같은 정보들을 수집합니다.<br>
 - 통화이력 및 녹음 파일<br>
<br>
나. 수집방법<br>
1) 홈페이지를 통한 서비스 이용, 이벤트 응모, 전화, 팩스, 고객센터 문의 및 상담<br>
2) 생성정보 수집 툴을 통한 수집<br>
<br>
<span style="font-weight: bold;">2. 개인정보의 수집 및 이용목적</span><br>
HOW는 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br>
ο 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산 콘텐츠 제공, 구매 및 요금 결제, 본인인증<br>
ο 회원 관리<br>
회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지,<br>
가입 의사 확인, 연령확인, 불만처리 등 민원처리, 고지사항 전달<br>
ο 마케팅 및 광고에 활용<br>
신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재,<br>
접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계<br>
ο 기타<br>
가입횟수 제한, 분쟁조정을 위한 기록보존, 회원의 각종 합격유무 확인 및 기타 통계자료 산출<br>
<br>
<span style="font-weight: bold;">3. 개인정보의 보유 및 이용기간</span><br>
회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다.<br>
파기절차 및 방법은 다음과 같습니다.<br>
ο 파기절차:회원님이 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후<br>
별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한<br>
정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다.<br>
별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되지 않습니다.<br>
ο 파기방법:전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.<br>
ο 보유기간:이용계약에 따른 회원자격이 유지되는 기간동안<br>
그러나 회원탈퇴 후에도 관계법령의 규정에 의하여 보존할 필요가 있는 경우 HOW는 아래와 같이 일정 기간동안 회원정보를 보관합니다.<br>
회원 및 비회원 통화 이력은 상담 종료 후 30일동안 보관된 후 파기됩니다.<br>
<br>
<span style="font-weight: bold;">4. 개인정보의 파기절차 및 방법</span><br>
개인정보의 보유 및 이용기간은 다음과 같습니다.<br>
ο 보유항목:수집항목과 같습니다.<br>
ο 보유근거:이용약관 및 개인정보취급방침<br>
ο 보유기간:이용계약에 따른 회원자격이 유지되는 기간동안 그러나 회원탈퇴 후에도 관계법령의 규정에 의하여<br>
보존할 필요가 있는 경우 HOW는 아래와 같이 일정 기간동안 회원정보를 보관합니다.<br>
표시/광고에 관한 기록 : 6개월 (전자상거래등에서의 소비자보호에 관한 법률)<br>
계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)<br>
대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)<br>
소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)<br>
신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)<br>
통신비밀보호법에 따른 통신사실확인자료 3개월<br>
<br>
<span style="font-weight: bold;">5. 개인정보</span><br>
HOW는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<br>
이용자들이 사전에 동의한 경우<br>
- 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우<br>
<br>
<span style="font-weight: bold;">6. 수집한 개인정보의 위탁</span><br>
HOW는 고객님의 동의없이 고객님의 정보를 외부 업체에 위탁하지 않습니다.<br>
향후 그러한 필요가 생길 경우, 위탁 대상자와 위탁 업무 내용에 대해 고객님에게 통지하고 필요한 경우 사전 동의를 받도록 하겠습니다.<br>
<br>
<span style="font-weight: bold;">7. 이용자 및 법정대리인의 권리와 그 행사방법</span><br>
이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를<br>
조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다.<br>
이용자 혹은 만 14세 미만 아동의 개인정보 조회를 위해서는 ‘정보수정’ 을,<br>
가입해지(동의철회)를 위해서는 "회원탈퇴"를 클릭 하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다.<br>
혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다.<br>
귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전 까지 개인정보를 이용 또는 제공하지 않습니다.<br>
또한 잘못된 개인정보를 제3자 에게 이미 제공한 경우에는<br>
정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 하겠습니다.<br>
HOW는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는<br>
HOW가 수집하는 개인정보의 보유 및 이용기간"에 명시된 바에 따라 처리하고<br>
그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.<br>
<br>
<span style="font-weight: bold;">8. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</span><br>
HOW는 귀하의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)' 등을 운용합니다.<br>
쿠키란 HOW의 웹사이트를 운영하는데 이용되는 서버가<br>
귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 귀하의 컴퓨터 하드디스크에 저장됩니다.<br>
HOW는 다음과 같은 목적을 위해 쿠키를 사용합니다.<br>
쿠키 등 사용 목적<br>
- 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적,<br>
각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공<br>
쿠키 설정 거부 방법<br>
- 쿠키 설정을 거부하는 방법으로는 회원님이 사용하시는 웹 브라우저의 옵션을 선택함으로써<br>
모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.<br>
- 설정방법 예(인터넷 익스플로러의 경우): 웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보<br>
(단, 귀하께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.)<br>
<br>
<span style="font-weight: bold;">9. 개인정보 위탁 현황</span><br>
고객지원 및 서비스 제공을 위해 아래와 같이 개인정보 취급 업무를 외부 업체에 위탁하여 운영하고 있습니다.<br>
위탁계약시 개인정보보호의 안전을 기하기 위하여 개인정보보호 관련 지시 엄수,<br>
개인정보에 관한 유출금지 및 사고시의 책임부담 등을 명확히 규정하고 위탁계약 내용에 포함하고 있습니다.<br>
<span style="font-weight: bold;">수탁업체</span>&emsp;&emsp;<span style="font-weight: bold; margin-left:30px">위탁목적</span><br>
㈜다우기술&nbsp;&nbsp;&nbsp;<span style="margin-left:10px;">SMS 발송대행</span><br>
<br>
<span style="font-weight: bold;">10. 개인정보 관리 책임자</span><br>
HOW는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여<br>
아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.<br>
개인정보관리책임자 성명 : 이은경 본부장<br>
전화번호 : 02-518-0036 (평일 : 9시 ~ 6시까지)<br>
이메일 : ashleylee@carrotglobal.com<br>
<br>
기타 개인정보 침해에 대한 신고나 상담이 필요한 경우에 아래 기관에 문의 가능합니다.<br>
개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)<br>
대검찰청 사이버수사과 (www.spo.go.kr / 국번없이 1301)<br>
경찰청 사이버수사국 (police.go.kr / 국번없이 182)<br>
<br>
<span style="font-weight: bold;">11. 고지의 의무</span><br>
현 개인정보취급방침 내용 추가, 삭제 및 수정이 있을 시에는<br>
변경사항 시행일의 7일전부터 홈페이지를 통해 고지할 것입니다.<br>
- 공고일자: 2021년 5월 26일<br>
- 시행일자: 2021년 6월 2일<br>
            </div>
        </div>
        <div class="footer">
         <div class="wrap">
             <div class="call">
                 <h3>CONTACT</h3>
                 <div class="call-con">
                     <p class="number">02-518-2603</p>
                     <p class="time"><span>상담시간</span>월~금 : 09:00AM~18:00PM</p>
                     <p>helphow@carrotglobal.com</p>
                 </div>
             </div>
             <div class="address">
                 <p>
                     서울특별시 강남구 강남대로 488 대남빌딩 4~9층 06120 │ ㈜캐럿글로벌 대표이사 : 노상충<br>
                     사업자등록번호: 211-88-50791 통신판매업신고번호 제 2017-서울강남-02979호 | <span @click="private_go()" style="cursor:pointer">개인정보처리방침</span> · <span @click="terms()" style="cursor:pointer">이용약관</span><br>
                     Copyright © <span class="bold">CARROT</span> Inc. All Rights reserved.<br>
                 </p>
                 <select name="" id="footer_select">
                     <option value="">Family Site</option>
                     <option value="http://www.carrotglobal.com/" target="_blank">CARROT HUB</option>
                     <option value="http:////www.carrotenglish.kr" target="_blank">전화영어:모바일 화상</option>
                     <option value="http://www.carrotglobal.com/global/" target="_blank">기업교육:글로벌 역량</option>
                     <option value="http://www.carrotglobal.net" target="_blank">CARROT Global</option>
                     <option value="http://www.how-writing.com/how/main.php" target="_blank">HOW</option>
                     <option value="//www.thespac.net" target="_blank">SPAC</option>
                     <option value="//www.imooc.co.kr" target="_blank">i:MOOC</option>
                 </select>
            </div>
         </div>
     </div>
        <div class="how-layer-bg" v-if="is_login">
            <div class="how-layer">
                <a href="#" class="float-right layer-close" @click="is_login = false">
                    <img src="../../assets/img/how/layer_close.png" alt="">
                </a>
                <div class="top">
                    <h1><img src="../../assets/img/how/logo_on.png"></h1>
                    <p>HOW Writing 역량강화 센터에 오신걸 환영합니다! </p>
                </div>
                <div class="login-box">
                    <div class="login-form">
                        <input placeholder="ID(E-Mail)를 입력해 주세요." class="input-login" v-model="info.email">
                    </div>
                    <p class="txt-alert" v-if="is_err_id">ID(E-Mail)를 입력해 주세요.</p>
                    <div class="login-form">
                        <input placeholder="비밀번호를 입력해 주세요." class="input-login" v-model="info.pw" type="password">
                    </div>
                    <p class="txt-alert" v-if="is_err_pw">비밀번호를 다시 확인해 주세요.</p>
                    <div class="login-setting">
                        <input type="checkbox" class="login-check" v-model="is_save" @change="saveIdpw()">
                        <label for="stln" class="lab-check">ID/PW 기억하기</label>
                    </div>
                    <button class="btn-login" @click="doSubmit()">로그인</button>
                    <!-- <div class="login-rel">
                        <span href="retyrb fa" style="cursor: pointer;" @click="showPwpop()" data-toggle="modal" data-target="#passwordModal">비밀번호를 잊으셨나요?</span>
                    </div> -->
                </div>
            </div>
        </div>
        <PwPopupModal :visible="pwVisible" @close="vue_close"></PwPopupModal>
    </div>
</template>
<script>
    import PwPopupModal from '../../components/pop_findPw.vue'
    export default {
        name: 'HowPrivacy',
        components: {
            PwPopupModal
        },
        data: () => ({
            pwVisible: false,
            info: {
                email: "",
                pw: ""
            },
            is_err_id: false,
            is_err_pw: false,
            is_save: false,
            is_login: false,
            is_mobile_menu: false,
            msg: ""
        }),
        mounted() {
            if (location.hostname == "stagest.carrotenglish.net") {
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            } else if (location.hostname == "st.carrotenglish.net") {
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            } else if (location.hostname == "student.carrotenglish.net") {
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            } else if (location.hostname == "m.carrotenglish.net") {
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            } else if (location.href.includes("how")) {
                if (location.href.includes("stage")) {
                    this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                } else {
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }
            } else {
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
            this.is_save = false;
            if (localStorage.getItem("email") != null || localStorage.getItem("email") != "") {
                this.info.email = localStorage.getItem("email");
                this.info.pw = localStorage.getItem("pw");
                if (this.info.email == 'null') {
                    this.info.email = '';
                }
                if (this.info.pw == 'null') {
                    this.info.pw = '';
                }
                if (localStorage.getItem("is_save") == "1") {
                    this.is_save = true;
                } else {
                    this.is_save = false;
                }
            } else {
                this.info.email = "";
                this.info.pw = "";
                this.is_save = false;
                if (localStorage.getItem("is_save") == "1") {
                    this.is_save = true;
                } else {
                    this.is_save = false;
                }
            }
        },
        methods: {
            terms:function(){
                location.href="/how_terms";
            },
            private_go:function(){
                location.href="/how_privacy";
            },
            saveIdpw: function () {
                if (this.is_save == true) {
                    localStorage.setItem("email", this.info.email);
                    localStorage.setItem("pw", this.info.pw);
                    localStorage.setItem("is_save", "1");
                } else {
                    localStorage.setItem("email", "");
                    localStorage.setItem("pw", "");
                    localStorage.setItem("is_save", "0");
                }
            },
            showPwpop: function () {
                // this.is_login = false;
                // this.pwVisible = true;
                alert("비밀번호 재설정을 희망하시면, 02-518-2603으로 연락 부탁 드립니다.");
            },
            vue_close: function (state) {
                this.pwVisible = state;
                this.is_login = true;
            },
            doSubmit: function () {
                var me = this;
                console.log(me.info.email);
                if (me.info.email == "") {
                    this.is_err_id = true;
                    return false;
                } else {
                    this.is_err_id = false;
                }
                if (me.info.pw == "") {
                    this.is_err_pw = true;
                    return false;
                } else {
                    this.is_err_pw = false;
                }

                if (this.is_save == true) {
                    localStorage.setItem("email", this.info.email);
                    localStorage.setItem("pw", this.info.pw);
                    localStorage.setItem("is_save", "1");
                } else {
                    localStorage.setItem("email", "");
                    localStorage.setItem("pw", "");
                    localStorage.setItem("is_save", "0");
                }

                var email = this.info.email;
                var password = this.info.pw;
                this.$store.dispatch('LOGIN', {
                        email,
                        password
                    })
                    .then(() => this.redirect())
                    .catch(({
                        message
                    }) => this.msg = message)
                console.log(this.msg);
            }
        }
    }
</script>

<style lang="scss" scoped>
    // 폰트

    @font-face {
        font-family: 'Noto Sans KR', sans-serif;
        font-style: normal;
        font-weight: normal;
    }

    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&family=Roboto:wght@900&display=swap" rel="stylesheet');

    // 공통
    $point-color: #2a72ec;

    * {
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    html {
        height: 100%;
    }

    body {
        font-family: 'Noto Sans KR', sans-serif;
        font-weight: 300;
        font-size: 18px;
        margin: 0;
        height: 100%;
        color: #474341;
        word-break: keep-all;
    }

    button {
        font-family: 'Noto Sans KR', sans-serif;
    }

    .body {
        min-height: 100%;
        position: relative;
        padding-bottom: 70px;
        overflow-x: hidden
    }

    .wrap {
        max-width: 1200px;
        width: 100%;
        margin: 0 auto;
        position: relative;
        padding-bottom: 10%;
    }

    .phone {
        display: none;
    }

    .phoneblock {
        display: none;
    }

    .phone-dp {
        display: inline-block;
    }

    input[type="text"],
    input[type="password"],
    select,
    textarea {
        height: 45px;
        padding: 10px;
        border: 1px solid #ccc;
        font-family: 'Noto Sans KR', sans-serif;
        font-size: 18px;

        &::placeholder {
            color: #a1a1a1;
            font-weight: 200;
        }
    }

    /*풋터*/
    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        background: #373737;
        color: #cecece;
        padding: 30px 0;

        .address {
            font-size: 13px;
            font-weight: 100;
            float: left;
            width: 50%;

            p {
                margin-bottom: 20px;
                line-height: 25px;
            }

            select {
                border: none;
                padding: 5px 10px;
            }
        }

        .call {
            float: right;
            width: 45%;

            h3 {
                font-weight: bold;
                font-size: 18px;
                margin-bottom: 15px;
            }

            .call-con {
                width: 100%;
                border-top: 1px solid #dadada;
                padding-top: 15px;

                .number {
                    font-size: 25px;
                    font-weight: 500;
                }

                .time {
                    font-size: 13px;
                    letter-spacing: 1px !important;

                    span {
                        margin-right: 10px;
                    }
                }
            }
        }
    }

    /*상단네비*/
    .main-navi {
        position: absolute;
        width: 100%;
        z-index: 54;

        .navi-wrap {
            width: 100%;
            max-width: 1200px;
            margin: 0 auto;

            h1 {
                float: left;
            }

            .pc-navi {
                float: right;

                li {
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 14px;
                    font-weight: bold;
                    position: relative;
                    margin-top: 10px;

                    &:last-child {
                        a {
                            padding-right: 0;
                        }
                    }

                    span {
                        display: block;
                        color: #fff;
                        padding: 15px 20px;
                    }

                    .pc-navi-dropmenu {
                        display: none;
                        position: absolute;
                        background: #fff;
                        z-index: 10;
                        left: -20px;
                        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
                        -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
                        -moz-box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);

                        li {
                            display: block;

                            &:hover {
                                background: #deebf1;
                            }

                            a {
                                display: block;
                                padding: 5px 40px;
                            }
                        }
                    }
                }
            }

            .m-navi {
                display: none;
            }

            .m-navi-btn {
                display: none;
            }
        }
    }

    /*메인*/
    .main-visual {
        background: #deebf1;
        background: url("../../assets/img/how/main_img.png") no-repeat left top;
        width: 100%;
        min-height: 400px;

        .how-title-wrap {
            padding-top: 200px;

            h2 {
                font-size: 40px;
                font-weight: bold;
                color: #fff;
            }

            h3 {
                color: #fff;
                padding-top: 15px;
                font-size: 20px;
            }
        }
    }

    .index-con {
        padding: 100px 0;

        h3 {
            font-size: 40px;
            font-weight: 700;
            margin-bottom: 30px;

            span {
                font-weight: 300;
            }
        }

        .how {
            position: relative;
            margin-bottom: 120px;

            .title {
                float: left;

                p {
                    line-height: 30px;
                }
            }

            .visual {
                position: absolute;
                right: 0;
                top: -15px;
                z-index: -1;
            }
        }

        .how-test {
            text-align: center;
            padding: 0 0 120px 0;

            ul {
                li {
                    display: inline-block;
                    vertical-align: top;
                    margin-right: 30px;

                    &:last-child {
                        margin-right: 0px;
                    }

                    .title {
                        font-weight: bold;
                        font-size: 21px;
                        margin-bottom: 15px;
                    }
                }
            }
        }

        .how-to {
            text-align: center;
            padding: 120px 0 120px 0;
            background: url(../../assets/img/how/how_to_img.png) no-repeat left top;
            color: #fff;

            .how-list {
                width: 1000px;
                margin: 50px auto 0 auto;

                .title {
                    background: #52CAFF;
                    padding: 15px 0;
                    font-size: 20px;
                    font-weight: bold;
                    border-radius: 25px 25px 0 0;
                }

                .con-box {
                    background: #fff;
                    padding: 50px;
                    border-radius: 0 0 25px 25px;

                    p {
                        font-size: 18px;
                        color: #373737;

                        &.how-to-img {
                            padding-top: 20px;
                        }
                    }
                }
            }
        }

        .how-process {
            width: 100%;
            padding: 120px 0 120px 0;
            text-align: center;

            h3 {
                margin-bottom: 50px;
            }

            ul {
                li {
                    display: inline-block;
                    vertical-align: top;
                    padding: 0 14px;

                    &:first-child {
                        padding-left: 0;
                    }

                    &:nth-child(2n) {
                        padding-top: 80px;
                    }

                    &:last-child {
                        padding-right: 0;
                    }

                    .title {
                        font-weight: bold;
                        font-size: 21px;
                        padding: 15px 0;
                    }

                    a {
                        font-size: 15px;
                        color: #005e9e;
                        font-weight: bold;
                        display: inline-block;
                        margin-top: 15px;

                        &::after {
                            display: block;
                            content: '';
                            border-bottom: 1px solid #005e9e;
                        }
                    }
                }
            }
        }

        .how-index {
            text-align: center;
            padding: 120px 0 0 0;
            background: url(../../assets/img/how/how_platform.png) no-repeat left top;

            ul {
                width: 100%;
                text-align: left;
                margin-top: 48px;

                li {
                    display: inline-block;

                    &.txt {
                        width: 400px;
                        text-align: left;
                        vertical-align: top;
                        margin-top: 100px;
                        font-size: 20px;

                        .sub {
                            padding-top: 15px;
                        }
                    }

                    &.phone-img {
                        width: 796px;
                        margin-left: -300px;
                    }
                }
            }
        }

        .how-class {
            text-align: center;
            padding: 120px 0 120px 0;
            background: url(../../assets/img/how/how_class_bg.png) no-repeat left top;
            color: #fff;
            background-size: cover;

            img {
                float: left;
                margin-top: 90px;
            }

            ul {
                // width: 1000px;
                width: 750px;
                margin: 50px auto 0 auto;
                margin-left: 54px;
                float: left;

                li {
                    border-radius: 15px;
                    background: #fff;
                    color: #373737;
                    padding: 20px;
                    margin-bottom: 30px;

                    p {
                        display: inline-block;
                        vertical-align: middle;

                        &.title {
                            width: 25%;
                        }

                        &.sub {
                            width: 74%;
                            // padding: 0 0 0 50px;
                            padding-left: 20px;
                            border-left: 1px dotted #999;
                            text-align: left;
                        }
                    }
                }
            }
        }
    }

    // 로그인 레이어 팝업
    .how-layer-bg {
        background-color: rgba(0, 0, 0, 0.7);
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 99999;
        overflow: auto;
        -ms-overflow-style: none;

        .how-layer {
            min-width: 500px;
            max-width: 600px;
            margin: 0 auto 50px auto;
            margin-top: 100px;
            background-color: #FFF;
            z-index: 9999;
            display: block;
            white-space: nowrap;
            position: relative;
            padding: 50px 0;

            .top {
                text-align: center;

                p {
                    font-size: 16px;
                }
            }

            .layer-close {
                display: inline-block;
                position: absolute;
                right: 0px;
                top: -50px;

                img {
                    width: 30px;
                }
            }

            .login-box {
                width: 80%;
                margin: 40px auto 00px auto;
                display: block;
                padding-bottom: 20px;

                .login-form {
                    position: relative;
                    margin-top: 10px;
                    border: 1px solid #dadada;
                    font-size: 15px;

                    input {
                        &.input-login {
                            display: block;
                            width: 100%;
                            height: 40px;
                            padding: 0 15px;
                            border: 0;
                            font-weight: bold;
                            font-size: 15px;
                            line-height: 25px;
                            color: #1e1e1e;
                            vertical-align: top;
                            background-color: transparent;
                            outline: 0;
                        }
                    }

                    .txt-alert {
                        color: #ff6969;
                        font-size: 12px;
                        margin: 5px 0 10px 0;
                        display: none;
                    }
                }

                .login-setting {
                    margin-top: 10px;

                    .lab-check {
                        font-size: 16px;
                    }
                }

                .btn-login {
                    width: 100%;
                    padding: 13px 0;
                    text-align: center;
                    background: #404040;
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: bold;
                    color: #ffffff;
                    margin: 30px 0 0 0;
                    border: none;
                }

                .login-rel {
                    text-align: center;
                    font-size: 16px;
                    margin-top: 30px;
                }
            }
        }

    }


    // 반응형 시작

    /*반응형 - 아이패드프로 (세로) 기준*/
    @media only screen and (max-width: 1024px) {

        /*공통*/
        .body {
            min-height: 100%;
            position: relative;
            padding-bottom: 320px;
        }

        .wrap {
            width: 95%;
        }

        /*네비 (메인)*/
        .main-navi {
            .navi-wrap {
                width: 95%;
                padding: 10px 0;

                h1 {
                    margin-top: 0;
                    width: 150px;

                    img {
                        width: 100%;
                    }
                }

                .pc-navi {
                    display: none;
                }

                .m-navi-btn {
                    display: block;
                    float: right;
                    font-size: 16px;
                    color: #fff;
                    font-weight: bold;
                    margin-top: 10px;
                }

                .m-navi {
                    // position: absolute;
                    position: fixed;
                    top: 0;
                    right: 0;
                    z-index: 999;
                    height: 100%;
                    min-height: 100%;
                    background: #fff;
                    width: 310px;
                    display: block;

                    .m-navi-top {
                        display: block;
                        padding: 20px;

                        a {
                            // color: #fff;
                            float: right;
                        }
                    }

                    .m-navi-con {
                        .m-navi-li {
                            border-bottom: 1px solid #eeeeee;

                            a {
                                padding: 10px 20px;
                                display: block;
                            }
                        }
                    }
                }
            }
        }

        .main-visual {
            .wrap {
                padding-top: 200px;

                .how-title-wrap {
                    margin-top: 0;
                    width: 90%;
                    margin: 0 auto;
                    text-align: center;
                }
            }
        }

        .index-con {
            .how-test {
                padding: 0 0 40px 0;

                ul {
                    li {
                        margin-bottom: 30px;
                        width: 100%;

                        p {
                            &.title {
                                font-size: 18px;
                            }

                            &.sub {
                                font-size: 16px;
                            }
                        }

                        img {
                            width: 100%;
                        }
                    }
                }
            }

            .how-to {
                padding: 50px 0;

                .how-list {
                    width: 100%;
                    margin: 40px auto 0 auto;

                    .title {
                        padding: 15px;
                        font-size: 18px;
                    }

                    .con-box {
                        padding: 20px;

                        p {
                            font-size: 16px;

                            &.how-to-img {
                                img {
                                    width: 100%;
                                }
                            }
                        }
                    }
                }
            }

            .how-process {
                padding: 50px 0;

                ul {
                    li {
                        width: 40%;
                        margin-right: 6%;
                        padding: 0;

                        img {
                            width: 100%;
                        }

                        &:nth-child(2n) {
                            display: none;
                        }

                        &:nth-child(3n) {
                            margin-right: 0;
                        }

                        .title {
                            font-size: 16px;
                        }
                    }
                }
            }

            .how-index {
                padding: 50px 0 0 0;

                ul {
                    width: 100%;
                    text-align: left;
                    margin-top: 30px;

                    li {
                        &.txt {
                            width: 100%;
                            margin-top: 0;
                            text-align: center;
                            margin-bottom: 30px;
                            font-size: 20px;

                            p {
                                &.title {
                                    width: 100%;
                                }

                                &.sub {
                                    padding-top: 20px;
                                    font-size: 16px;
                                }
                            }
                        }

                        &.phone-img {
                            width: 100%;
                            margin-left: 0;

                            img {
                                width: 100%;
                            }
                        }
                    }
                }
            }

            .how-class {
                padding: 50px 0;
                background-size: cover;

                .wrap {
                    img {
                        width: 100%;
                        margin-top: 30px;
                    }
                }

                ul {
                    width: 100%;
                    margin: 30px auto 0 auto;

                    li {
                        padding: 20px;
                        margin-bottom: 30px;

                        p {
                            &.title {
                                width: 100%;
                                padding-bottom: 15px;
                                border-bottom: 1px dotted #999;
                            }

                            &.sub {
                                width: 100%;
                                padding: 0;
                                border-left: 0;
                                font-size: 16px;
                                text-align: center;
                                padding-top: 15px;
                            }
                        }
                    }
                }
            }
        }

        /*레이어 팝업*/
        .how-layer-bg {
            .how-layer {
                min-width: 90%;
                max-width: 90%;
                margin: 50px auto;

                .layer-close {
                    top: -40px;
                }

                .top {
                    text-align: center;
                    width: 90%;
                    margin: 0 auto;

                    p {
                        white-space: normal;
                        font-size: 14px;
                    }
                }

                .login-box {
                    width: 90%;
                    margin: 30px auto 00px auto;

                    .login-rel {
                        font-size: 14px;
                    }

                    .login-setting {
                        .lab-check {
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }

    /*반응형 - 아이패드 기준*/
    @media only screen and (max-width: 768px) {

        /*공통*/
        .body {
            min-height: 100%;
            position: relative;
            padding-bottom: 320px;
        }

        .wrap {
            width: 95%;
        }

        /*메인*/
        .main-visual {
            min-height: 600px;
            background-position-x: center;
            background-size: cover;

            .wrap {
                width: 100%;
                padding-top: 0;
            }

            .how-title-wrap {
                h2 {
                    font-size: 35px;
                }
            }
        }

        .index-con {
            padding: 60px 0 0px 0;

            h3 {
                font-size: 24px;
            }

            .how-test {
                p {
                    font-size: 16px;
                }
            }
        }

        /*풋터*/
        .footer {
            .address {
                float: none;
                width: 100%;
            }

            .call {
                float: none;
                width: 100%;
                margin-bottom: 20px;
            }
        }
    }

    /*반응형 - 아이폰플러스 기준*/
    @media only screen and (max-width: 414px) {

        /*공통*/
        .m-br {
            display: block;
        }

        .phone-disnone {
            display: none !important;
        }

        .body {
            padding-bottom: 382px;
        }
    }
</style>